// @ts-nocheck
import React, { useRef, useEffect, useState, useCallback } from 'react'
import { widget } from '../../charting_library'
import { useSelector } from 'react-redux'
import { selectCurrencies } from '../../state/currencies/reducer'
import axios from 'axios'
import noLogo from '../../assets/svg/noLogo.svg'
// import  '../ ./index.css';
// import   '../../index.css'
function debounce(func, wait) {
  let timeout
  return {
    call: function(...args) {
      clearTimeout(timeout)
      return new Promise(resolve => {
        timeout = setTimeout(() => {
          resolve(func(...args))
        }, wait)
      })
    },
    cancel: function() {
      clearTimeout(timeout)
    }
  }
}

const RESOLUTIONS = [
  { label: '1分钟', value: '1m', tvValue: '1', apiType: '1m', step: 60 },
  { label: '5分钟', value: '5m', tvValue: '5', apiType: '5m', step: 300 },
  { label: '15分钟', value: '15m', tvValue: '15', apiType: '15m', step: 900 },
  { label: '1小时', value: '1h', tvValue: '60', apiType: '1h', step: 3600 },
  { label: '4小时', value: '4h', tvValue: '240', apiType: '4h', step: 14400 },
  { label: '1天', value: '1d', tvValue: '1D', apiType: '1d', step: 86400 }
]

const BASE_API_URL = 'https://test-swap.bjwmls.com/api/Swap/PairKLineV2'
const MIN_TIME = 1609459200

interface OHLCVItem {
  o: number
  h: number
  l: number
  c: number
  unixTime: number
  vbase: number
}
interface APIData {
  code: number
  success: boolean
  data: OHLCVItem[]
  msg?: string
}
interface Bar {
  time: number
  open: number
  high: number
  low: number
  close: number
  volume: number
}

function getLanguageFromURL() {
  const regex = new RegExp('[\\?&]lang=([^&#]*)')
  const results = regex.exec(window.location.search)
  return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : 'en'
}

const cleanSymbol = symbol => symbol?.replace(/[^a-zA-Z0-9]/g, '').toUpperCase() || ''

function ftime(ts) {
  if (!ts) return '--'
  const d = new Date(ts * 1000)
  return `${d.getUTCFullYear()}-${('0' + (d.getUTCMonth() + 1)).slice(-2)}-${('0' + d.getUTCDate()).slice(-2)} ${(
    '0' + d.getUTCHours()
  ).slice(-2)}:${('0' + d.getUTCMinutes()).slice(-2)}`
}

function fillBars(bars, stepSec, from?, to?) {
  if (!bars.length) return []
  let sorted = bars.slice().sort((a, b) => a.time - b.time)
  let stepMs = stepSec * 1000
  let result = []
  let timeMap = new Map()
  sorted.forEach(b => timeMap.set(b.time, b))
  let t0 = from ? Math.max(sorted[0].time, from * 1000) : sorted[0].time
  let t1 = to ? Math.min(sorted[sorted.length - 1].time, to * 1000) : sorted[sorted.length - 1].time
  let prev = sorted[0]
  for (let t = t0; t <= t1; t += stepMs) {
    if (timeMap.has(t)) {
      prev = timeMap.get(t)
      result.push({ ...prev })
    } else {
      result.push({
        time: t,
        open: prev.close,
        high: prev.close,
        low: prev.close,
        close: prev.close,
        volume: 0
      })
    }
  }
  return result
}

function mergeBars(apiBars, localBars, stepSec) {
  const all = [...apiBars, ...localBars]
  const uniq = new Map()
  all.forEach(b => uniq.set(b.time, b))
  let arr = Array.from(uniq.values()).sort((a, b) => a.time - b.time)
  if (arr.length > 1) arr = fillBars(arr, stepSec)
  return arr
}

export default function TVChartContainer() {
  const chartRef = useRef(null)
  const tvWidgetRef = useRef(null)
  const chartInstance = useRef(null)
  const barsCache = useRef([])
  const apiOptionsRef = useRef({ baseAddress: '', quoteAddress: '', apiType: '15m', step: 60 })
  const lastFromRef = useRef(null)

  const [resolution, setResolution] = useState(RESOLUTIONS[4].value)
  const [isLoading, setIsLoading] = useState(false)
  const { inputCurrency, outputCurrency } = useSelector(selectCurrencies)

  const [jsonData, setJsonData] = useState([])
  async function getJson() {
    try {
      let data = await axios.get('https://website.bjwmls.com/static/tokenlist.json')
      setJsonData(data.data.tokens)
    } catch (error) {
      console.error('[getJson Error]', error)
    }
  }

  function getLogoURIByAddress(address) {
    if (!address) {
      address = '0x0970E625B92025AeA9b78148F596B5Fa6516a018'
    }
    const lowerCaseAddress = address.toLowerCase()
    const foundItem = jsonData?.find(item => item.address.toLowerCase() === lowerCaseAddress)
    return foundItem ? foundItem.logoURI : noLogo
  }

  const getSymbolAndApi = useCallback(() => {
    const symbol =
      inputCurrency?.symbol && outputCurrency?.symbol
        ? `${cleanSymbol(inputCurrency.symbol)}/${cleanSymbol(outputCurrency.symbol)}`
        : 'USDT/TOK'
    const baseAddress =
      inputCurrency?.symbol?.toLowerCase() === 'dor'
        ? '0x0970E625B92025AeA9b78148F596B5Fa6516a018'
        : inputCurrency?.address || ''
    const quoteAddress =
      outputCurrency?.symbol?.toLowerCase() === 'dor'
        ? '0x0970E625B92025AeA9b78148F596B5Fa6516a018'
        : outputCurrency?.address || ''
    const r = RESOLUTIONS.find(r => r.value === resolution) || RESOLUTIONS[2]
    return { symbol, baseAddress, quoteAddress, apiType: r.apiType, step: r.step }
  }, [inputCurrency, outputCurrency, resolution])

  const fetchDataRaw = useCallback(async (from, to, apiType, baseAddress, quoteAddress) => {
    // console.log(`[API请求] from=${from} (${ftime(from)}), to=${to} (${ftime(to)}) 类型: ${apiType}`)
    setIsLoading(true)
    const apiUrl = `${BASE_API_URL}?baseAddress=${quoteAddress}&quoteAddress=${baseAddress}&type=${apiType}&from=${from}&to=${to}`
    try {
      const response = await fetch(apiUrl)
      const result = await response.json()
      // console.log('[API返回]', result)
      if (result.code === 0 && result.data?.length > 0) {
        return result.data.map(item => ({
          time: item.unixTime * 1000,
          open: item.o,
          high: item.h,
          low: item.l,
          close: item.c,
          volume: item.vbase
        }))
      }
      return []
    } catch (error) {
      console.error('[fetchData Error]', error)
      return []
    } finally {
      setIsLoading(false)
    }
  }, [])

  const fetchData = debounce(fetchDataRaw, 500)

  useEffect(() => {
    // console.log('初始化')
    getJson()

    if (tvWidgetRef.current || !chartRef.current) return
    const r = RESOLUTIONS.find(r => r.value === resolution) || RESOLUTIONS[2]
    const { symbol, baseAddress, quoteAddress, apiType, step } = getSymbolAndApi()
    apiOptionsRef.current = { baseAddress, quoteAddress, apiType, step }

    const datafeed = {
      onReady: cb => {
        cb({
          supports_search: true,
          supports_group_request: false,
          supported_resolutions: RESOLUTIONS.map(r => r.tvValue)
        })
      },
      resolveSymbol: (symbolName, onSymbolResolvedCallback, onResolveErrorCallback) => {
        const [base, quote] = symbolName.split('/')
        if (!base || !quote) {
          onResolveErrorCallback('Invalid symbol format')
          return
        }
        onSymbolResolvedCallback({
          name: symbolName,
          full_name: `Custom:${symbolName}`,
          type: 'crypto',
          session: '24x7',
          timezone: 'Etc/UTC',
          ticker: symbolName,
          minmov: 1,
          pricescale: 1000000,
          has_intraday: true,
          has_daily: true,
          has_weekly_and_monthly: true,
          supported_resolutions: RESOLUTIONS.map(r => r.tvValue),
          volume_precision: 2
        })
      },
      getBars: async (symbolInfo, tvRes, params, onHistoryCallback) => {
        const { from, to } = params
        let { step } = apiOptionsRef.current
        const resolutionObj = RESOLUTIONS.find(r => r.tvValue === tvRes) || RESOLUTIONS[2]
        const apiType = resolutionObj.apiType
        let cache = barsCache.current
        let cacheFrom = cache.length > 0 ? Math.floor(cache[0].time / 1000) : undefined
        let cacheTo = cache.length > 0 ? Math.floor(cache[cache.length - 1].time / 1000) : undefined
        // console.log(
        //   `[getBars] TV from: ${from} (${ftime(from)}) to: ${to} (${ftime(to)}) | 缓存: ${cacheFrom} (${ftime(
        //     cacheFrom
        //   )}) ~ ${cacheTo} (${ftime(cacheTo)})`
        // )

        let fetchTo = to
        if (lastFromRef.current && from < lastFromRef.current) {
          fetchTo = lastFromRef.current
        }
        lastFromRef.current = from

        let needFetch = !cacheFrom || from < cacheFrom
        if (needFetch && apiOptionsRef.current.baseAddress && apiOptionsRef.current.quoteAddress) {
          const fetchFrom = Math.max(MIN_TIME, from)
          // console.log(
          //   '[fetchData 调用]',
          //   fetchFrom,
          //   fetchTo,
          //   apiOptionsRef.current.apiType,
          //   apiOptionsRef.current.baseAddress,
          //   apiOptionsRef.current.quoteAddress
          // )

          const apiBars = await fetchData.call(
            fetchFrom,
            fetchTo,
            apiType, // 使用从 tvRes 派生的 apiType
            apiOptionsRef.current.baseAddress,
            apiOptionsRef.current.quoteAddress
          )
          if (apiBars && apiBars.length) {
            barsCache.current = mergeBars(apiBars, barsCache.current, step)
            cache = barsCache.current
            cacheFrom = cache.length > 0 ? Math.floor(cache[0].time / 1000) : undefined
            cacheTo = cache.length > 0 ? Math.floor(cache[cache.length - 1].time / 1000) : undefined
            // console.log(`[merge后缓存] ${cacheFrom} (${ftime(cacheFrom)}) ~ ${cacheTo} (${ftime(cacheTo)})`)
          }
        }

        const barsForTv = cache.filter(bar => {
          const t = bar.time / 1000
          return t >= from && t <= to
        })
        if (barsForTv.length) {
          // console.log(
          //   `[返回TV] ${barsForTv.length} 根, [${barsForTv[0]?.time / 1000}][${ftime(
          //     barsForTv[0]?.time / 1000
          //   )}] ~ [${barsForTv[barsForTv.length - 1]?.time / 1000}][${ftime(
          //     barsForTv[barsForTv.length - 1]?.time / 1000
          //   )}]`
          // )
          onHistoryCallback(barsForTv, { noData: false })
        } else {
          // console.log(`[返回TV] 空数据`)
          onHistoryCallback([], { noData: true })
        }
      },
      subscribeBars: () => {},
      unsubscribeBars: () => {}
    }
    const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    tvWidgetRef.current = new widget({
      symbol,
      interval: r.tvValue,
      container: chartRef.current,
      datafeed,
      library_path: '/charting_library/',
      custom_css_url: '/TradingView.css',
      locale: getLanguageFromURL(),
      enabled_features: ['study_templates'],
      charts_storage_url: 'https://saveload.tradingview.com',
      charts_storage_api_version: '1.1',
      client_id: 'tradingview.com',
      user_id: 'public_user_id',
      fullscreen: false,
      autosize: true,
      studies_overrides: {},
      debug: false,
      load_last_chart: false,
      loading_screen: false,
      timezone: localTimezone,
      loading_screen: {
        backgroundColor: '#F4FDFF', // 透明背景
        // foregroundColor: 'rgba(0, 0, 0, 0)', // 透明 spinner
      },
      disabled_features: [
        'header_symbol_search',
        'header_compare',
        'header_quick_search',
        'symbol_info',
        'create_volume_indicator_by_default',
        'allow_arbitrary_symbol_search_input',
        'symbol_info_long_description',
        'show_exchange_logos',
        'symbol_info',
        'symbol_search_hot_key',
        'header_saveload',
        'symbol_info',
        'show_exchange_logos',
        'timezone_menu',
        // 'timeframes_toolbar',
        'header_symbol',
        'save_chart_properties_to_local_storage', // 禁用本地存储
        'use_localstorage_for_settings', // 禁用本地设置存储
        
        // 'auto_enable_symbol_labels'
      ],
      enabled_features: [
        'hide_left_toolbar_by_default',
        'study_overlay_compare_legend_option',
        'study_overlay_compare_legend_option'
      ],
      overrides: {
        'paneProperties.background': '#F4FDFF', // 图表绘图区背景（红色）
        'scalesProperties.backgroundColor': '#F4FDFF' // 坐标轴背景
      }
      
    })

    tvWidgetRef.current.onChartReady(() => {
      chartInstance.current = tvWidgetRef.current.activeChart()
      chartInstance.current.onIntervalChanged().subscribe(null, tvInterval => {
        const res = RESOLUTIONS.find(r => r.tvValue === tvInterval)
        if (res && res.value !== resolution) {
          try {
            chartInstance.current.executeActionById('chartReset')
          } catch (error) {
          }
          setResolution(res.value)
          lastFromRef.current = null
        }
      })
      chartInstance.current.applyOverrides({
        'paneProperties.background': '#F4FDFF',
        'scalesProperties.backgroundColor': '#F4FDFF'
      })
    })

    return () => {
      tvWidgetRef.current?.remove()
      tvWidgetRef.current = null
    }
  }, [])

  // useEffect(()=>{
  //   if (chartInstance?.current?.applyOverrides) {
  //     console.log('开始处理');
  //     chartInstance.current.applyOverrides({
  //       'paneProperties.background': '#F4FDFF',
  //       'scalesProperties.backgroundColor': '#F4FDFF'
  //     })
      
  //   }
  // },[chartInstance?.current?.applyOverrides])

  useEffect(() => {
    // console.log('发生变化')

    if (!inputCurrency?.symbol || !outputCurrency?.symbol) return
    // console.log('币种切换:', inputCurrency.symbol, outputCurrency.symbol)

    const { symbol, baseAddress, quoteAddress, apiType, step } = getSymbolAndApi()
    apiOptionsRef.current = { baseAddress, quoteAddress, apiType, step }
    barsCache.current = []
    lastFromRef.current = null
    fetchData.cancel()
    // try {
    //   chartInstance.current.applyOverrides({
    //     'paneProperties.background': '#F4FDFF',
    //     'scalesProperties.backgroundColor': '#F4FDFF'
    //   })
    // } catch (error) {
    //   console.log('错误',error);
      
    // }

    if (tvWidgetRef.current && chartInstance.current) {
      const selectedRes = RESOLUTIONS.find(r => r.value === resolution)?.tvValue || '15'
      chartInstance.current.setSymbol(symbol, selectedRes, async () => {
        if (typeof chartInstance.current.resetData === 'function') {
          chartInstance.current.resetData()
        }
        const now = Math.floor(Date.now() / 1000)
        const from = now - 86400 * 7
        const apiBars = await fetchData.call(
          from,
          now,
          apiOptionsRef.current.apiType,
          apiOptionsRef.current.baseAddress,
          apiOptionsRef.current.quoteAddress
        )
        if (apiBars && apiBars.length) {
          barsCache.current = mergeBars(apiBars, [], step)
          chartInstance.current.dataReady(() => {
            const bars = barsCache.current.filter(bar => bar.time / 1000 >= from && bar.time / 1000 <= now)
            return bars
          })
        }
      })
    }
  }, [inputCurrency, outputCurrency, resolution, getSymbolAndApi])

  return (
    <>
      <div
        style={{
          position: 'relative',
          maxWidth: '750px',
          flexGrow: 1,
          background: '#F4FDFF',
          border: '1px solid #c9f7ff'
        }}
      >
        <div className="header-box">
          <div className="avt">
            <div className="img">
              <img src={getLogoURIByAddress(inputCurrency?.address)} alt="" />
            </div>
            <div className="img">
              <img src={getLogoURIByAddress(outputCurrency?.address)} alt="" />
            </div>
          </div>
          <div className="text-title">
            {inputCurrency?.symbol}/{outputCurrency?.symbol}
          </div>
        </div>
        <div ref={chartRef} style={{ width: '100%', height: '500px' }} />
      </div>
      {/* 
      <div>
        <br /> Powered by Dovra Chain
      </div> */}
    </>
  )
}